'use strict';

var Params = function Params(dataLength, additionalLeftPadding) {
  return function (containerWidth, containerHeight) {
    var padding = {
      top: 10,
      bottom: 77,
      left: 20 + additionalLeftPadding,
      right: 15
    };
    var barWidth = 30;
    var width = dataLength * barWidth;
    var height = containerHeight - (padding.top + padding.bottom);
    return {
      width: width,
      height: height,
      containerWidth: containerWidth,
      containerHeight: containerHeight,
      padding: padding,
      yNumberOfTicks: 5,
      xAxisShift: 0,
      yAxisShift: -50,
      yAxisLabelShift: -10,
      xAxisLabelShift: -50,
      forceWidth: true
    };
  };
};
module.exports = Params;